import React, { useState } from "react";
import { SVGMap } from "react-svg-map";
import Russia from "maps/russia";
import "maps/russia/index.css";
import PropTypes from "prop-types";

export default function RussianMap({
    highlightedRegions,
    withoutHighlightRegions,
    onMapRegionClick,
}) {
    const [currentLocationName, setCurrentLocationName] = useState(null);
    const [toolTipStyle, setToolTipStyle] = useState({
        display: "none",
    });

    const handleLocationClick = function (event) {
        if (highlightedRegions.includes(Number(event.target.id))) {
            onMapRegionClick(event.target.id);
        }
    };

    const handleLocationMouseOver = function (event) {
        const pointedLocation = getLocationName(event);
        setCurrentLocationName(pointedLocation);
    };

    const handleLocationMouseOut = function () {
        setCurrentLocationName(null);
        setToolTipStyle({ display: "none" });
    };

    const handleLocationMouseMove = function (event) {
        const tooltipStyle = {
            display: "flex",
            top: event.clientY + 90,
            left: event.clientX + 10,
        };
        setToolTipStyle(tooltipStyle);
    };

    const getLocationName = function (event) {
        return event.target.attributes.name.value;
    };

    const getLocationClassName = function (location, index) {
        if (highlightedRegions.includes(location.id)) return `svg-map__location--top100`;
        else if (withoutHighlightRegions.includes(location.id))
            return `svg-map__location--not_top100`;
        else return `svg-map__location`;
    };

    return (
        <>
            <SVGMap
                map={Russia}
                locationClassName={getLocationClassName}
                onLocationMouseOver={handleLocationMouseOver}
                onLocationMouseOut={handleLocationMouseOut}
                onLocationMouseMove={handleLocationMouseMove}
                onLocationClick={handleLocationClick}
            />
            <div className="map__tooltip" style={toolTipStyle}>
                {currentLocationName}
            </div>
        </>
    );
}

RussianMap.propTypes = {
    highlightedRegions: PropTypes.array.isRequired,
    withoutHighlightRegions: PropTypes.array.isRequired,
    onMapRegionClick: PropTypes.func.isRequired,
};
